import {
	timetableRequestIdentity,
	useTimetableRequestIdentity,
} from "@features/timetables/settingsQueries";
import {
	queryOptions,
	useQuery,
	useSuspenseQuery,
} from "@tanstack/react-query";
import { getStudentCurrentLesson } from "./api";

export const studentCurrentLessonQueryOptions = (
	studentNo: string,
	identity = timetableRequestIdentity(),
) =>
	queryOptions({
		queryKey: ["studentCurrentLesson", ...identity, studentNo],
		queryFn: () => getStudentCurrentLesson(studentNo),
		staleTime: 30_000,
	});

export function useStudentCurrentLesson(studentNo: string) {
	return useQuery(
		studentCurrentLessonQueryOptions(studentNo, useTimetableRequestIdentity()),
	);
}

export function useStudentCurrentLessonSuspense(studentNo: string) {
	return useSuspenseQuery(
		studentCurrentLessonQueryOptions(studentNo, useTimetableRequestIdentity()),
	);
}
